import axios from 'axios';
import { AppUrls, } from '../../services/Globals';
import { Config } from '../../services/Config';
import { templates } from '../../utils';

export const cargarDocsFunctions = {}

cargarDocsFunctions.doNextStage = (obj) => {
  if (sessionStorage.getItem('token')) {
    //Objeto lleno
    let config = {
      pathname: `/${obj.nextComponent}`,
      //pathname: `/DynamicFormComponent`,
      state: {
        stageName: obj.stageName,
        stageId: obj.stageId,
        stage: obj.stage,
        folioId: obj.folioId,
        actorId: obj.actorId
      }
    }
    //Objeto lleno
    obj.navigate(config)
  }
  else {
    alert("No se encontró usuario.")
  }
}

cargarDocsFunctions.nextIndocLoading = (obj) => {
  let config = {
    pathname: `/${obj.nextComponent}`,
    //pathname: `/DynamicFormComponent`,
    state: {
      folioId: obj.folioId,
      actorId: obj.actorId,
      sectionId: obj.sectionId,
      sections: obj.sections,
      docName: obj.docName,
      sectionName: obj.sectionName,
      ocrInfo: obj.ocrInfo,
      qrProcess: obj.qrProcess,
      metadatos: obj.metadatos,
      doc: obj.doc,
      pdf: obj.pdf,
      activeNSections: obj.activeNSections,
      docCurrentNameCapture: obj.docCurrentNameCapture,
      sectionsCapture: obj.sectionsCapture,
      noCurentCapture: obj.noCurentCapture,
      typeOcrCaptureCurrent: obj.typeOcrCaptureCurrent,
      b64Document: obj.b64Document,
    }
  }
  //Objeto lleno
  obj.navigate(config)

}

cargarDocsFunctions.toLastQrView = (obj) => {
  let config = {
    pathname: `/${obj.nextComponent}`,
    //pathname: `/DynamicFormComponent`,
    state: {
      currentStage: obj.currentStage,
      totalStage: obj.totalStage,
    }
  }
  //Objeto lleno
  obj.navigate(config)
}

const handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}

cargarDocsFunctions.sendResponses = async (array, folio, extension, actorId) => {
  const responses = array.map(async (doc) => {
    return await axios.post(
      AppUrls.UploadSectionApi,
      Config.SetParameters({
        B64Content: doc.document,
        FileId: folio,
        Actor_Id: actorId,
        SkipActor: null,
        SectionId: doc.secId,
        Extension: extension,
        Skip: false,
        SkipReason: null,
        Metadata: doc.metadata,
        ContinueWorkFlow: false, //to upload all files before moving
        Geolocation: null, //Pending
        DeferLoad: false // heavy file, true to load on backgroud 
      }, '', '', ''),
      Config.ConfigAuth()
    ).then(handleResponse)
  })

  return await Promise.all(responses)
}

cargarDocsFunctions.getOcrValue = (array) => {
  let ocr = array.find(e => e.Name == "OcrCapture")
  let type = array.find(e => e.Name == "TypeOcrCapture")
  console.log("ocr-----------------: ", ocr)
  if (ocr === undefined) {
    return {
      ocr: 0,
      type: 'Online'
    }
  } else {
    return {
      ocr: ocr.Value,
      type: type.Value
    }
  }
}

//new 
cargarDocsFunctions.getNewFieldName = (name) => {
  console.log("Metadato----getNewFieldName-----: ", name.toUpperCase())
  const field = templates?.find(doc => doc.DocumentType === name.toUpperCase());
  console.log("Metadato----getNewFieldName---field--: ", field)
  if (field === undefined || field === null || field == "") {
    console.log("No se encontró Template configurado para el documento: " + name.toUpperCase())
    return null;
  }

  return field.Fields
}

